import { render, staticRenderFns } from "./DashboardBenchmarkFilter.vue?vue&type=template&id=63c55374&scoped=true"
import script from "./DashboardBenchmarkFilter.vue?vue&type=script&lang=js"
export * from "./DashboardBenchmarkFilter.vue?vue&type=script&lang=js"
import style0 from "./DashboardBenchmarkFilter.vue?vue&type=style&index=0&id=63c55374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c55374",
  null
  
)

export default component.exports